
import { useEffect, useRef, useState } from "react";

//threshold -> déclenche l'event en fonction de la visibilité de l'element sur la page (par défaut 10%)
export function useInViewAnimation(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    //Permet de detecter si l'element est dans le viewport
    const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && ref.current) {
        setIsVisible(true);
        observer.unobserve(ref.current); // Optionnel : stop l'observation
      }
    },
    { threshold }
  );

  if (ref.current) {
    observer.observe(ref.current);
  }

  return () => {
    if (ref.current) observer.unobserve(ref.current);
  };
}, [threshold]);

  return { ref, isVisible };
}